import type { CarrierPricings } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import { useInvalidateCarriersQuery } from "./use-carriers-query";

export function useEditCarrierPriciings(shopId: string) {
	const invalidateShop = useInvalidateCarriersQuery({ shopId });

	return useApiMutation(
		"patch",
		"/shops/{shopId}/carriers/{carrierId}/pricings/prices/{carrierId}",
		{
			invalidate: invalidateShop,
			mapVariables: ({
				pricings,
				carrierId,
			}: {
				pricings: CarrierPricings[];
				carrierId: string;
			}) => ({
				params: { path: { shopId, carrierId } },
				body: pricings,
			}),
		},
	);
}
